import React from 'react';
import PropTypes from 'prop-types';
import bemComponent from '@99designs/utils/app/bemComponent';

export class Frame extends React.Component {
    render() {
        var data = {};

        if (this.props.isSidebarHidden) {
            data['data-sidebar-hidden'] = true;
        }

        if (this.props.isAnimatable) {
            data['data-animatable'] = true;
        }

        return (
            <div className="fullscreen-frame" {...data}>
                {this.props.children}
            </div>
        );
    }
}

Frame.propTypes = {
    isSidebarHidden: PropTypes.bool,
    isAnimatable: PropTypes.bool,
};

Frame.defaultProps = {
    isSidebarHidden: false,
    isAnimatable: false,
};

export const Main = bemComponent('fullscreen-frame__main', 'Main');
export const Sidebar = bemComponent('fullscreen-frame__sidebar', 'Sidebar');



// WEBPACK FOOTER //
// ./~/@99designs/fullscreen/components/Frame.js